import { useNavigate } from "react-router-dom";
import './Footer.css';

const Footer = () => {
	const navigate = useNavigate();

	return (
	    <div className="Footer">
            Copyright &copy; <span onClick={() => navigate('/catalog/about')} style={{cursor:'pointer'}}>ExpoVisionRus</span>
        </div>
	);
};

export default Footer;
